import type React from 'react';

import { RoleListFiltersProvider } from '@vlabs/monokit/entities/roles';
import type { GetRolesParams } from '@vlabs/api/artemy/model';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import { RoleListTableViewer } from '@vlabs/monokit/widgets/roles';
import { DEFAULT_PAGE_SIZE } from '@vlabs/uikit/constants';

import { RoleListPageHeader } from './header/RoleListPageHeader';

const defaultRoleListFilters: GetRolesParams = {
  page: 1,
  page_size: DEFAULT_PAGE_SIZE,
  sort: 'create_time',
  order: 'desc',
};

function RoleListPage(): React.JSX.Element {
  return (
    <Page>
      <RoleListFiltersProvider initialData={defaultRoleListFilters}>
        <PageContent>
          <RoleListPageHeader />
          <RoleListTableViewer />
        </PageContent>
      </RoleListFiltersProvider>
    </Page>
  );
}

export { RoleListPage };
